import { useLocation } from 'react-router';
import { getTableModeSwitcherStyles } from 'client/js/main/screens/ScreenRoiHub/styles';
import { ImageService } from 'client/js/main/services/ImageService/ImageService';
import { selectReportActiveMode, selectRoiAnalyticsReportTableState } from 'client/js/main/selectors/RoiHub';
import { useDispatch, useSelector } from 'client/js/redux';
import type { ActiveMode } from '../../types';
import { setPageState } from 'client/js/common/actions/ShareableActions';
import { ROI_ANALYTICS_NAMESPACE } from '../../../../../../../shared/constants';
import { ROI_ANALYTICS_TABLE } from '../../../../../../../shared/constants/analytics/contexts';

const useTableModeSwitcherService = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const activeMode = useSelector(selectReportActiveMode);
  const reportTableState = useSelector(selectRoiAnalyticsReportTableState);

  const iconPath = ImageService.getImageUrl('/static/images/roi-hub/tree-view-icon.svg');

  const css = getTableModeSwitcherStyles(activeMode, iconPath);

  const updateActiveMode = (updatedActiveMode: ActiveMode) => {
    const data = { [ROI_ANALYTICS_TABLE]: { ...reportTableState, activeMode: updatedActiveMode } };
    dispatch(setPageState(ROI_ANALYTICS_NAMESPACE, data));
  };

  const onTreeButtonClick = () => {
    updateActiveMode('tree');
  };

  const onFlatButtonClick = () => {
    updateActiveMode('flat');
  };

  return {
    isOnRoiAnalytics: pathname === '/ads/roi-hub/analytics',
    css,
    onTreeButtonClick,
    onFlatButtonClick,
  };
};

export default useTableModeSwitcherService;
